import { render, staticRenderFns } from "./InventoryFormDetails.vue?vue&type=template&id=720897ce"
import script from "./InventoryFormDetails.vue?vue&type=script&lang=js"
export * from "./InventoryFormDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports